const columns = [
  {
    title: "热门IP",
    links: ["火影忍者", "海贼王", "咒术回战", "鬼灭之刃", "排球少年"],
  },
  {
    title: "快速导航",
    links: ["首页", "精选作品", "最新更新", "关于我们", "常见问题"],
  },
  {
    title: "创作支持",
    links: ["投稿入驻", "创作者中心", "版权规范", "友情链接", "意见反馈"],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-800/80 py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <a href="#home" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-primary-500 to-accent-600 text-lg text-background-50">
                <i className="ri-ancient-pavilion-line"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                同人<span className="text-primary-400">漫研</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              火影、海贼王、咒术回战、鬼灭之刃、排球少年等热门IP同人漫画聚合站，按IP分类整理，持续更新，让每一份热爱都被看见。
            </p>
            <div className="mt-5 flex items-center gap-2.5">
              {[
                { icon: "ri-wechat-line", label: "微信公众号" },
                { icon: "ri-bilibili-line", label: "哔哩哔哩" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-mail-line", label: "邮箱" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#subscribe"
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-700 text-foreground-400 transition-colors hover:bg-accent-500/20 hover:text-accent-300"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-950">
                {col.title}
              </h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#home"
                      className="text-sm text-foreground-500 transition-colors hover:text-accent-300"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200/40 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 同人漫研 · 热门IP同人动漫二创合集站</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-3-line text-primary-400"></i>
            为热爱而创作，尊重每一份二创
          </p>
        </div>
      </div>
    </footer>
  );
}